class BracciLoader extends HTMLElement {
  constructor() {
    super();
    this.unlockPage = this.unlockPage.bind(this);
    this.preventScroll = this.preventScroll.bind(this);
    
    this.timeoutDuration = 1000;
  }

  connectedCallback() {
    this.lockPage();
    setTimeout(this.unlockPage, this.timeoutDuration);
  }

  // Intercepta e anula a tentativa de scroll
  preventScroll(e) {
    e.preventDefault();
  }

  lockPage() {
    // 1. Trava via CSS (Desktop)
    document.documentElement.classList.add('locked-scroll');
    document.body.classList.add('locked-scroll');
    
    // 2. Trava via Eventos (Mobile / iOS Safari / Mouse)
    window.addEventListener('touchmove', this.preventScroll, { passive: false });
    window.addEventListener('wheel', this.preventScroll, { passive: false });

    this.classList.remove('bracci-hidden');
  }

  unlockPage() {
    this.classList.add('bracci-hidden');
    
    // 1. Libera via CSS
    document.documentElement.classList.remove('locked-scroll');
    document.body.classList.remove('locked-scroll');
    
    // 2. Libera via Eventos
    window.removeEventListener('touchmove', this.preventScroll);
    window.removeEventListener('wheel', this.preventScroll);
  }
}

customElements.define('bracci-loader', BracciLoader);
